import React, { ReactNode } from 'react';

import { Link } from 'react-router-dom';
import classNames from 'classnames';

import CartDropdown from './CartDropdown';
import UserDropdown from './UserDropdown';
import { icons } from '../../../helpers/icons';
import { useAppSelector } from '../../../hooks/hooks';
import { NAVIGATE_PATH } from '../../../helpers/constants';

interface INavHeader {
  label: string | ReactNode;
  action?: ReactNode;
  className?: string;
  showGuestLogin?: boolean;
}

const NavHeader: React.FC<INavHeader> = ({
  label,
  action,
  className,
  showGuestLogin = true,
}) => {
  const { user } = useAppSelector((state) => state.userReducer);
  const isImpersonated = localStorage.getItem('impersonated') === 'true';

  return (
    <div
      className={classNames(
        'py-2 px-4 lg:pl-6 guest:pl-4 sticky top-0 z-50 rounded-t-lg',
        isImpersonated ? 'bg-red-300' : 'bg-white',
        className,
      )}
    >
      <div className="flex justify-between guest:guest-wrapper guest:mx-auto">
        <div className="flex items-center justify-between gap-2 py-2 pr-2 grow">
          <div className="text-heading-dark">{label}</div>
          <div className="flex items-center gap-2">
            {action}
            <div className="hidden text-xs leading-5 underline cursor-pointer text-grey-700">
              Filter
            </div>
          </div>
        </div>
        <div className="flex items-center">
          <div className="flex items-center gap-2">
            <div className="hidden">
              <form>
                <div className="relative">
                  <div className="absolute inset-y-0 flex items-center pointer-events-none start-0 ps-4">
                    <img src={icons.search} className="w-4 h-4" alt="search" />
                  </div>
                  <input
                    type="search"
                    id="default-search"
                    className="header-input"
                    placeholder="Search"
                  />
                </div>
              </form>
            </div>
            <div className="hidden cursor-pointer shrink-0">
              <img src={icons.bell} alt="notification" />
            </div>

            {isImpersonated && (
              <span className="hidden text-base font-bold md:block text-core-dark">
                (Impersonated)
              </span>
            )}

            <div className="flex items-center gap-2 max-lg:flex-row-reverse">
              {user && (
                <>
                  <UserDropdown />
                  <div className="h-8 border-r" />
                </>
              )}
              <CartDropdown />
              {!user && showGuestLogin && (
                <>
                  <div className="h-8 border-r" />
                  <Link
                    to={NAVIGATE_PATH.login}
                    className="font-medium text-regular text-core-dark hover:underline"
                  >
                    Login
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavHeader;
